export interface CompanyInfo {
  /** 公司id */
  id: number;
  createTime: string;
  currencyMap: CurrencyMap;
  contactPhone: any;
  uuid: string;
  companyName: string;
  industry: any;
  sourceCategory: string;
  contactEmail: string;
  defaultSenderName: string;
  defaultSenderEmail: string;
  defaultSenderPhone: string;
  country: string;
  province: string;
  city: string;
  address: string;
  zipCode: string;
  name: string;
  scale: any;
  site: string;
  currency: string;
  currencyFormat: string;
  currencySymbol: any;
  timezone: string;
  timezoneFormat: string;
  status: number;
  nextStep: number;
  previousStep: number;
  emailInterval: number;
  utm: string;
  campaignChannel: string;
  orderAttributionMethod: string;
  orderAttributionWindow: number;
  optimization:boolean;
  integrationType: string;
  shop: string;
  ipPoolName: any;
  flowIpPoolName: string;
  campaignIpPoolName: string;
  flowUtm: string;
  campaignUtm: string;
  preheatingExemption: boolean;
  shopContactEmail: string;
  shopName: string;
  integrateStatus: string;
  completeTime: string;
  subscribeCallback: any;
  /** 沉默用户展示: silence true 开启, false关闭 */
  silence: boolean;
  replyToEmail: string;
  preheatStartTime: string;
  boostFilter: boolean;
  utmSourceOpen: boolean;
  utmMediumOpen: boolean;
  utmCampaignOpen: boolean;
  utmContectOpen: boolean;
  utmTermOpen: boolean;
  flowUtmSource: string;
  flowUtmMedium: string;
  flowUtmCampaign: string;
  flowUtmContect: string;
  flowUtmTerm: string;
  campaignUtmSource: string;
  campaignUtmMedium: string;
  campaignUtmCampaign: string;
  campaignUtmContect: string;
  campaignUtmTerm: string;
  gmailPromotion: boolean;
  /** Coi展示: emailDoubleCheck: true开启, false关闭 */
  emailDoubleCheck: boolean;
  emailCleaning: boolean;
  appKey: string;
  campaignSms: boolean;
  appName: string;
  flowAppPushOpen: boolean;
  sendgridLinkReplaceOpen: boolean;
  unsubscribeDescription: string;
  dynamicShortLink: string;
  shopifyFlag: number;
  selectCampaignEmailChannel: boolean;
  fenqunUserTopicOpen: boolean;
  loveProductOpen: boolean;
  easyPointsOpen: boolean;
  tabAuthority: string;
  emailTrackerTop: boolean;
  initShopName: boolean;
  sendCleanStorage: boolean;
  campaignRetryOpen: boolean;
  dmarc: boolean;
  generateBillOpen: boolean;
  campaignAutoModuleOpen: boolean;
  filterFreeProductOpen: boolean;
  titleLanguage: string;
  sameLandingPageCollectionsOpen: number;
  unsubscribeUrlLevel: any;
  flowRetryOpen: boolean;
  emailTemplateTranslateOpen: number;
  dataMaskingOpen: boolean;
  simpleTimezone: string;
  /** true是新通道, false是旧通道 */
  newEmailChannel: boolean;
  /** 智能发送开关 */
  campaignIntelligenceStart: boolean;
  /** 0: 是存量的数据的 1: 是增量的，两个子账号的 */
  newSendgridSeparate: number;

  /** 短信 COI 开关 */
  smsDoubleCheck: boolean;
  /** 短信 COI 国家 */
  smsDoubleCheckCountry: string;
  /** 短信 COI 范围  'all' | 'form,upload,shop' */
  smsDoubleCheckScope: string;

  /** 客户系统折扣功能全局开关 */
  customDiscountOpen?: boolean;
  /** 弹窗 A/B Smart Test（guide/detail companyInfo，Nacos 计算） */
  formAbSmartTestOpen?: boolean;
  /** 手机号第二步推荐（guide/detail companyInfo，Nacos 计算） */
  phoneStepRecommendOpen?: boolean;
}

export interface CurrencyMap {
  CHF: string;
  MXN: string;
  ARS: string;
  SAR: string;
  CLP: string;
  ZAR: string;
  INR: string;
  CNY: string;
  AUD: string;
  KRW: string;
  ILS: string;
  JPY: string;
  PLN: string;
  GBP: string;
  IDR: string;
  BYN: string;
  PHP: string;
  TRY: string;
  RUB: string;
  HKD: string;
  AED: string;
  EUR: string;
  DKK: string;
  COP: string;
  USD: string;
  CAD: string;
  MYR: string;
  BGN: string;
  NOK: string;
  EGP: string;
  RON: string;
  SGD: string;
  SEK: string;
  NZD: string;
  BRL: string;
}

export type LocalStorageCompanyInfo = Partial<CompanyInfo>;

/** 从localStorage获取公司信息 */
export const getCompanyInfo = (): LocalStorageCompanyInfo => {
  return JSON.parse(localStorage.getItem('companyInfo') || '{}') as LocalStorageCompanyInfo;
};
